import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { onError } from '@apollo/client/link/error';
import { environment } from 'src/environments/environment';

const uri = environment.graphql_api_url;
export function createApollo(httpLink: HttpLink) {
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) console.error('GraphQL Errors:', graphQLErrors);
    if (networkError) console.error('Network Error:', networkError);
  });

  const http = ApolloLink.from([errorLink, httpLink.create({ uri })]);

  return {
    link: http,
    cache: new InMemoryCache(),
  };
}
